import { Backpack } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Inventory } from "@/components/game/Hud";

export const InventoryButton = ({ items, onRead }) => (
  <Popover>
    <PopoverTrigger asChild>
      <button className="pixel-btn ghost flex items-center gap-2 self-start" data-testid="inventory-toggle-button">
        <Backpack size={14} /> Inventory <span className="text-[#F59E0B]">{items.length}</span>
      </button>
    </PopoverTrigger>
    <PopoverContent align="start" side="top" className="w-80 rounded-none bg-[#12141C] border-2 border-[#2E3440] shadow-[6px_6px_0_#000] p-4" data-testid="inventory-panel">
      <p className="pixel-text text-base text-[#7DD3FC] tracking-widest mb-3">// INVENTORY — click an item to read it</p>
      <div className="max-h-64 overflow-y-auto"><Inventory items={items} onRead={onRead} /></div>
    </PopoverContent>
  </Popover>
);
